import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs2005',
    ecrans: ['00-2'],
    params:['id','?pjbprvcle','?pjbcleintref']
});
